<h2 mat-dialog-title>Conferma</h2>
<mat-dialog-content>
    Confermare la sessione UVM scelta?
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close>No</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onSend()">Sì</button>
</mat-dialog-actions>